import React, { useState, useEffect } from "react";
import { getData } from "app/data";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { ReactComponent as LeftSide } from "images/background/left-box-graphic.svg";
import { ReactComponent as RightSide } from "images/background/right-box-graphic.svg";
import { ReactComponent as BlueRectangle } from "images/background/software-solution-graphic-blue.svg";
import { ReactComponent as RedRectangle } from "images/background/software-solution-graphic-red.svg";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

const SoftwareSolution = () => {
  // const [activeBtn, setActiveBtn]=useState();
  // useEffect(()=>{
  //   if(window.location.pathname==="/"){
  //     setActiveBtn(true);
  //   }else{
  //     setActiveBtn(false);
  //   }
  // },[]);
  // const hoverBtnHandle=()=>{
  //   setActiveBtn(false);
  // }
  // const blurBtnHandle=()=>{
  //   setActiveBtn(true);
  // }

  return (
    <section className="softwareSolution">
      <div className="hg-bg-left">
        <LeftSide className="hg-bg-left" />
      </div>
      <RightSide className="hg-bg-right" />
      <div className="container">
        <div className="header">
          <h2 className="mb-5">
            <FormattedMessage id={"software_solution"} />
          </h2>
          <div className="d-flex flex-column flex-md-row  justify-content-center align-items-center p-2">
              <Link 
                to="/software-solution" 
                className="blue"
                // onMouseEnter={hoverBtnHandle} 
                // onMouseLeave={blurBtnHandle}
              >
                <FormattedMessage id={"software_sec_header_desc"}/>
              </Link>
              <Link 
                to="/software-solution-kiosk" 
                className="red"
                // onMouseEnter={hoverBtnHandle} 
                // onMouseLeave={blurBtnHandle}
              >
                <FormattedMessage id={"kiosk_title"}/>
              </Link>
          </div>
        </div>
        {getData("softwareSolution").map(item => {
          return (
            <div
              className={item.id % 2 !== 0 ? "row" : "row flex-row-reverse"}
              key={item.renderId}
            >
              <div
                className={`col-lg-6 col-sm-12 ${
                  item.class ? item.class : null
                }`}
              >
                <div className="text-wrapper">
                  <div className="title">
                    {item.id % 2 !== 0 ? <BlueRectangle /> : <RedRectangle />}
                    <h2>{item.title}</h2>
                  </div>
                  {item.text
                    ? item.text.map(textItem => (
                        <p key={textItem}>{textItem}</p>
                      ))
                    : null}
                  <div className="btn-wrapper">
                    <Link
                      className={
                        item.id % 2 !== 0 ? "green-button" : "accent-button"
                      }
                      to={item.link}
                    >
                      <FormattedMessage id={"learn_more"} />
                    </Link>
                  </div>
                </div>
              </div>
              <div
                className={`col-lg-6 col-sm-12 ${
                  item.class ? item.class : null
                }`}
              >
                <div className="image-wrapper">
                  <img src={item.img} alt="softwareSolution" />
                </div>
                <ul className={item.class ? item.class : null}>
                  {item.benefit.map(menu => (
                    <li key={menu.id}>
                      <span
                        className={item.id % 2 !== 0 ? "primary" : "accent"}
                      >
                        <FontAwesomeIcon icon={faCheckCircle} />
                      </span>
                      {menu.text}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default SoftwareSolution;
